module.exports = __webpack_public_path__ + "static/img/sanpal-poster.c7004b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sanpal-poster.png
// module id = zRzO
// module chunks = 0